import React from 'react'
import {Grid, makeStyles} from '@material-ui/core'
import { useSelector } from 'react-redux';
import BoardItem from './boardItem'
import {useDispatch} from 'react-redux'
import IntlMessages from 'util/IntlMessages';
import {getBoardListByUser} from 'actions'

const useStyles = makeStyles({

  reportTitle: {
    fontWeight: 500,
    fontSize: 30,
    display: 'flex',
    alignItems: 'center'
    // color: 'rgb(115, 115, 115)'
  },
  container: {
    width: '100%',
    maxWidth: 985,
    padding:'3rem 1rem'
  },
  outerContainer: {
    width: '100%',
		height: '100%',
    display: 'flex',
		overflow: 'scroll',
    backgroundColor:'transparent',
    justifyContent: 'center'
  },

})

export default function CampaignEdit(props) {
  const classes = useStyles()
  
  const userBoardList = useSelector(state => state.Projekt.userBoardList)
  const authUser = useSelector(state => state.auth.authUser)

	const dispatch = useDispatch()

	React.useEffect(()=>{
		dispatch(getBoardListByUser(authUser.user_id, authUser.user_Afid))
	},[])

  return (
    <div className={classes.outerContainer}>
      <div className={classes.container}>
        <Grid container spacing={3}>
          {
            userBoardList.map(b =>
            <Grid item xs={12}>
              <BoardItem board={b} handleSelectBoard={props.handleSelectBoard}/>
            </Grid> )
          }
        </Grid>
      </div>
    </div>
  )
}
